var _defs, _text, _text2, _rect, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoJignesh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1500 310",
    width: 1500,
    height: 310,
    role: "img",
    "aria-label": "Jignesh (JK) Kotadiya \\u2014 Inveterate lifetime learner, & technology explorer",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .jk-name { font-family: 'Raleway', 'Century Gothic', 'Trebuchet MS', 'Segoe UI', sans-serif; font-weight: 300; }\n      .jk-tag  { font-family: 'Raleway', 'Century Gothic', 'Trebuchet MS', 'Segoe UI', sans-serif; font-weight: 700; font-style: italic; }\n    "))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "jk-name",
    x: 8,
    y: 160,
    fontSize: 104,
    fill: "#f2f1e7",
    letterSpacing: 2,
    textLength: 1150,
    lengthAdjust: "spacingAndGlyphs"
  }, "Jignesh (JK) Kotadiya")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "jk-tag",
    x: 12,
    y: 244,
    fontSize: 32,
    fill: "#eceadd",
    letterSpacing: 1,
    textLength: 1150,
    lengthAdjust: "spacingAndGlyphs"
  }, "Inveterate lifetime learner, &amp; technology explorer")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1206,
    y: 12,
    width: 74,
    height: 286,
    fill: "#fdf200"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1306,
    y: 12,
    width: 74,
    height: 286,
    fill: "#fbf45c"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1406,
    y: 12,
    width: 74,
    height: 286,
    fill: "#fcf8a4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoJignesh);
export default __webpack_public_path__ + "static/media/logo-jignesh.78334117f459649c6f58333bff690c89.svg";
export { ForwardRef as ReactComponent };